import Slider from 'react-slick';
import classNames from 'classnames';
import { hoc } from '../../../packages';
import { useCarousel } from './carousel.props';
import styles from './carousel.module.scss';
import { Children } from 'react';

/**
 * Renders Carousel
 */
const AdvantagesCarousel = hoc(
  useCarousel,
  ({
    carouselRef,
    className,
    selectedIndex,
    setSelectedIndex,
    checkIsArrowHidden,
    children,
    onClickPrevSlide,
    onClickNextSlide,
    showArrows,
    count,
    ...props
  }) => {
    const _count = count ?? Children.count(children);

    return (
      <>
        <Slider
          ref={carouselRef}
          className={classNames(styles.carousel, className)}
          dots={false}
          infinite={false}
          beforeChange={(_: any, index: any) => setSelectedIndex(index)}
          {...props}
        >
          {children}
        </Slider>

        <div className={styles.btnContent}>
          <div
            className={classNames(styles.arrow, {
              [styles.arrow_hidden]: checkIsArrowHidden('prev', _count)
            })}
            onClick={onClickPrevSlide}
          >
            <img src='/img/arrowPrev.svg' alt='prev' />
          </div>
          {_count > 1 && (
            <div className={styles.indicators}>
              {Children.map(children, (_, index) => (
                <div
                  className={classNames(styles.indicator, {
                    [styles.indicator_active]: index === selectedIndex
                  })}
                  //@ts-ignore
                  onClick={() => carouselRef.current.slickGoTo(index)}
                />
              ))}
            </div>
          )}
          <div
            className={classNames(styles.arrow, {
              [styles.arrow_hidden]: checkIsArrowHidden('next', _count)
            })}
            onClick={onClickNextSlide}
          >
            <img src='/img/arrowNext.svg' alt='next' />
          </div>
        </div>
      </>
    );
  }
);

export { AdvantagesCarousel };
